
import React from 'react';
import HomePage from './components/HomePage';
import './styles.css';

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
